import styles from './Footer.module.css';

export const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <p className={styles.copyright}>
          &copy; {currentYear} Mejoramiento Genético Vegetal - FCA UNC
        </p>
        <p className={styles.description}>Material desarrollado con fines educativos</p>
        <div className={styles.credits}>
          <a
            href="https://www.linkedin.com/in/juan-marcelo-conrero/"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.creditLink}
            aria-label="LinkedIn de Juan Marcelo Conrero"
          >
            <span>Diseñado por Ing. Juan Marcelo Conrero</span>
            <svg viewBox="0 0 24 24" aria-hidden="true" className={styles.linkedinIcon}>
              <path d="M19 3H5C3.9 3 3 3.9 3 5v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM8.3 18.3H5.7V9.7h2.6v8.6zM7 8.5c-.8 0-1.4-.6-1.4-1.4S6.2 5.7 7 5.7s1.4.6 1.4 1.4S7.8 8.5 7 8.5zm11.3 9.8h-2.6v-4.2c0-1-.3-1.7-1.3-1.7-1 0-1.4.7-1.4 1.7v4.2h-2.6V9.7H13v1.2c.3-.6 1.1-1.4 2.3-1.4 2.1 0 3 1.4 3 3.6v5.2z" />
            </svg>
          </a>

          <a
            href="https://www.linkedin.com/in/sanchezsoria/"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.creditLink}
            aria-label="LinkedIn de Tomas Sanchez Soria"
          >
            <span>Desarrollado por Lic. Tomas Sanchez Soria</span>
            <svg viewBox="0 0 24 24" aria-hidden="true" className={styles.linkedinIcon}>
              <path d="M19 3H5C3.9 3 3 3.9 3 5v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM8.3 18.3H5.7V9.7h2.6v8.6zM7 8.5c-.8 0-1.4-.6-1.4-1.4S6.2 5.7 7 5.7s1.4.6 1.4 1.4S7.8 8.5 7 8.5zm11.3 9.8h-2.6v-4.2c0-1-.3-1.7-1.3-1.7-1 0-1.4.7-1.4 1.7v4.2h-2.6V9.7H13v1.2c.3-.6 1.1-1.4 2.3-1.4 2.1 0 3 1.4 3 3.6v5.2z" />
            </svg>
          </a>
        </div>
      </div>
    </footer>
  );
};
